import React from 'react';
import PropTypes from 'prop-types';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const ConfirmedByMonthChart = ({ data }) => {
  if (!data || data.length === 0) {
    return <p className="text-center text-muted">No data available</p>;
  }

  return (
    <ResponsiveContainer width="100%" height="100%" minHeight={300}>
      <BarChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="month" />
        <YAxis allowDecimals={false} />
        <Tooltip />
        <Bar dataKey="count" name="Confirmed" fill="#1cc88a" />
      </BarChart>
    </ResponsiveContainer>
  );
};

ConfirmedByMonthChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      month: PropTypes.string.isRequired,
      count: PropTypes.number.isRequired,
    })
  ).isRequired,
};

export default ConfirmedByMonthChart;
